import type { MenuItemOrderReportComponentProps } from './MenuItemOrderReportComponent';

export const MenuItemOrderReportComponent = {
    MountAsync: async (target: HTMLElement, props: MenuItemOrderReportComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { MenuItemOrderReportComponent } = await import('./MenuItemOrderReportComponent');
        return await mountReactComponentAsync(target, MenuItemOrderReportComponent, props);
    }
};
